import { createMetaRoute } from '@funtech-int/rival';

import { RouteMeta } from '@/shared/lib/navigation';

export const personRoute = createMetaRoute<RouteMeta, { id: string }>({
    key: (params) => params.id,
});
